import React from 'react';
import { AlertCircle, Trash2 } from 'lucide-react';
import '../styles/DeleteConfirmModal.css';

const DeleteConfirmModal = ({ showDeleteConfirm, setShowDeleteConfirm, handleDelete }) => {
  return (
    <div
      className="modal-overlay"
      onClick={() => setShowDeleteConfirm(null)}
    >
      <div
        className="delete-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="delete-icon-container">
          <AlertCircle size={32} color="#dc2626" />
        </div>

        <h3 className="delete-title">Delete Item?</h3>

        <p className="delete-message">
          Are you sure you want to delete this item? This action cannot be undone and the ID will not be reusable.
        </p>

        <div className="delete-buttons">
          <button
            onClick={() => setShowDeleteConfirm(null)}
            className="btn btn-cancel-delete"
          >
            Cancel
          </button>
          <button
            onClick={() => handleDelete(showDeleteConfirm)}
            className="btn btn-confirm-delete"
          >
            <Trash2 size={18} />
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;